const mediaMessages = {
  'media.description.title': '情報',
  'media.description.info.title.lat': '緯度',
  'media.description.info.title.lng': '経度',
  'media.description.info.title.tag': 'タグ',
  'media.description.info.title.group': 'グループ名',
  'media.description.info.title.tag.greater': ' > ',
  'media.description.info.title.recordedDate': '記録日時',
  'media.description.info.title.savedDate': '保存日時',
  'media.description.info.title.fileSize': 'ファイルサイズ',
  'media.description.info.title.operator': '作業者',
  'media.description.info.title.deviceName': 'デバイス名',
  'media.description.info.title.deviceNickname': 'デバイス表示名',
  'media.description.info.title.serialNumber': '端末シリアル',
  'media.description.info.title.gpsStatus': 'GPS状態',
  'media.description.info.title.orientation': '縦横情報',
  'media.detail.title': 'データ詳細',
  'media.detail.download.button.title': 'ダウンロード',
  'media.detail.analyze.button.title': '解析開始',
  'media.detail.updateTags.button.title': 'タグ・メモ編集',
  'media.detail.restore.button.title': '復元',
  'media.detail.send.button.title': '転送',
  'media.detail.nofile': 'NO FILE',
  'media.detail.analyze.title': '解析結果',
  'media.detail.analyze.statusMessage.0': '未解析',
  'media.detail.analyze.statusMessage.1': '解析中...',
  'media.detail.analyze.statusMessage.2': '解析失敗',
  'media.detail.analyze.statusMessage.3': 'NO DATA',
  'media.detail.message.analyzeOff.licenseExceeded':
    '解析ライセンスの上限を超えているため解析機能が無効です',
  'media.detail.message.analyzeFailed.licenseExceeded':
    '解析ライセンスの上限を超えるため解析できません',
  'media.detail.message.analyzeFailed.noLicense':
    '解析ライセンスがないため解析できません',
  'media.detail.message.analyzeFailed.analysisTimeExceeded':
    '解析時間の上限を超えるため解析できません',
  'media.detail.gpsStatus.statusMessage.on': '有効',
  'media.detail.gpsStatus.statusMessage.off.0': 'N/A',
  'media.detail.gpsStatus.statusMessage.off.1': '取得中',
  'media.detail.gpsStatus.statusMessage.off.2': 'GPS非搭載',
};

export default mediaMessages;
